import { PdfIcon } from '@/modules/MedComplex/Tabs/VerificationInfo/icons'
import { Box } from '@mui/material'
import type { PropsWithChildren } from 'react'
import { useEffect } from 'react'
import { styles } from './styles'
import type { PreviewImageProps } from './types'

export const PreviewFile = (props: PropsWithChildren<PreviewImageProps>) => {
  const { file, children } = props

  //const [fileName, setFileName] = useState(null)

  console.log(file)

  useEffect(() => {
    let isCancel = false
    let fileReader = new FileReader()
    if (file) {
      fileReader = new FileReader()
      // TODO
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      fileReader.onload = (e: any) => {
        const { result } = e.target
        if (result && !isCancel) {
          //setFileName(result)
        }
      }
      fileReader.readAsDataURL(file)
    }
    return () => {
      isCancel = true
      if (fileReader && fileReader.readyState === 1) {
        fileReader.abort()
      }
    }
  }, [file])

  return (
    <Box sx={styles.root}>
      <Box sx={styles.header}>{children}</Box>
      {/* {fileDataURL && <img src={fileDataURL ?? ''} alt="" />} */}
      {/* <Box sx={styles.pdfIcon}>
        <PdfIcon />
        <Box sx={styles.title}>
          {`${item.ext_file_id}.pdf`}
        </Box>
      </Box> */}
      <PdfIcon />
    </Box>
  )
}
